import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { IserverService } from './iserver.service';
import * as GeneratedModel from '../types/generated-model.type';
import buildQuery from 'odata-query';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ModelService {
  constructor(private iserverService: IserverService) {}

  getModels(): Observable<GeneratedModel.Gen_Model[]> {
    const query = buildQuery({});
    const url = `${environment.iServerUrl}/odata/Models${query}`;
    return this.iserverService.query(url).pipe(map((res) => res['value']));
  }
}
